module.exports = __webpack_public_path__ + "img/desktop2.b489c000.png";